"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(props) {
  var _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
      onChange = props.onChange,
      value = props.value,
      onClick = props.onClick,
      _props$classNameMap = props.classNameMap,
      classNameMap = _props$classNameMap === void 0 ? {} : _props$classNameMap,
      clear = props.clear,
      propsOnClear = props.onClear;
  var onClear; // 如果是undefined的那就默认与onChange结合

  if (typeof propsOnClear === 'undefined') {
    onClear = function onClear(event) {
      onChange(_objectSpread({}, event, {
        target: {
          value: ''
        }
      }));
    };
  } else {
    onClear = propsOnClear;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(classNameMap.SelectSearchClassName, {
      'has-clear': clear && value
    })
  }, _react["default"].createElement("input", {
    onClick: onClick,
    type: "text",
    value: value,
    placeholder: placeholder,
    onChange: onChange
  }), clear && value ? _react["default"].createElement("div", {
    className: "spaui-input-clear",
    role: "button",
    onClick: onClear
  }, _react["default"].createElement("svg", {
    viewBox: "0 0 16 16",
    width: "16px",
    height: "16px"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    fillRule: "evenodd",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    d: "M5.333 5.333l5.334 5.334M10.667 5.333l-5.334 5.334",
    stroke: "#FFF",
    strokeLinecap: "square"
  }))) : null);
};

exports["default"] = _default;